import { useState } from "react";
import { TbChevronDown, TbChevronUp } from "react-icons/tb";
import PropTypes from "prop-types";

const ToggleDropdown = ({ title, content }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <div className="p-2 card-base-border rounded-md shadow-md">
      <div
        className="flex items-center cursor-pointer space-x-2 p-2 rounded-md gap-2 justify-between"
        onClick={() => setDropdownOpen(!dropdownOpen)}
      >
        <div className="flex items-center gap-2">
          <p className="font-semibold">{title}</p>
        </div>
        {dropdownOpen ? <TbChevronUp size={20} /> : <TbChevronDown size={20} />}
      </div>
      <div
        className={`mt-2 text-sm background-page-color card-base-border rounded-md overflow-hidden transition-all duration-400 ease-in-out ${
          dropdownOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        {dropdownOpen && <p className="p-4 gap-1 flex flex-col">{content}</p>}
      </div>
    </div>
  );
};

ToggleDropdown.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.array.isRequired,
};

export default ToggleDropdown;
